import React, { FC, useEffect, useRef } from 'react';
import { Messages } from '@src/containers/Messages';
import { ChatMessagesProps } from './props';
import './styles.scss';

export const ChatMessages: FC<ChatMessagesProps> = ({ messages, user, opening }) => {
  const messagesWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const setScrollBottom = () => {
      if (messagesWrapperRef.current) {
        messagesWrapperRef.current.scrollTop = messagesWrapperRef.current.scrollHeight;
      }
    };

    setScrollBottom();
  }, [messages.length]);

  return (
    <div className="inbox-chat-messages-wrapper" ref={messagesWrapperRef}>
      <Messages messages={messages} openingTitle={opening?.title || undefined} user={user} />
    </div>
  );
};
